/**
 * The title the server writes until it has generated a real one. `useChatTitle` polls
 * while it is still in place, so it must stay byte-identical to the backend's English.
 */
// eslint-disable-next-line i18next/no-literal-string -- sentinel compared against the server's value, never rendered
export const DEFAULT_CHAT_TITLE = 'Untitled Chat';
